/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import styled from 'styled-components';
import { Avatar, AvatarSkeleton, Icon } from '@oneaudi/unified-web-components';
import { useProfilePicture } from '../../hooks/use-profile-picture';
import { NAVIGATION_CLASSNAME } from '../../utils/globals';
import type { IdkConfig } from '../../hooks/use-env-config';

const StyledAvatar = styled(Avatar)`
  & img {
    position: inherit;
  }
  background-color: var(--one-header-color-black);
  margin: 0;
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

const AvatarIcon: React.FC<{
  idk: IdkConfig | undefined;
  initials: string;
  flyoutLabel: string;
  loading: boolean;
  error: string | null;
}> = ({ idk, initials, flyoutLabel, loading, error }) => {
  const profilePicture = useProfilePicture(idk);

  if (error && typeof error === 'string') {
    return <StyledIcon name="user-active" size="s" data-testid="StyledIcon" />;
  }

  if (loading || profilePicture?.loading) {
    // @ts-expect-error
    return <AvatarSkeleton size="xs" data-testid="AvatarSkeleton" />;
  }

  return profilePicture?.src ? (
    <StyledAvatar
      aria-label={flyoutLabel}
      size="sm"
      label={initials}
      image={{
        src: profilePicture.src,
        alt: 'profile picture',
        role: 'presentation',
      }}
      variant="logged-in"
      onClick={() => {}}
      data-testid="StyledAvatar"
      className={NAVIGATION_CLASSNAME}
    />
  ) : (
    <>
      {initials ? (
        <StyledAvatar
          aria-label={flyoutLabel}
          size="sm"
          label={initials}
          variant="logged-in"
          onClick={() => {}}
          data-testid="StyledAvatar"
          className={NAVIGATION_CLASSNAME}
        />
      ) : (
        <StyledIcon name="user-active" size="s" data-testid="StyledIcon" />
      )}
    </>
  );
};

export default AvatarIcon;
